import type { RecurringTransaction } from "@/lib/types/recurring-transactions";
import { RECURRING_TRANSACTIONS_CONFIG } from "@/features/recurring-transactions/components/RecurringTransactionsConfig";
import { ENHANCED_RECURRING_TRANSACTION_DETAIL_CONFIG } from "@/features/recurring-transactions/components/RecurringTransactionDetailConfig";
import { getFieldValue } from "@/components/shared/UniversalCRMTable/components/SimpleTable/tableCellFieldValue";
import { defineEntity } from "../types";

// ============================================================================
// RECURRING TRANSACTIONS ENTITY DEFINITION
// ============================================================================
// Column change: edit features/recurring-transactions/components/RecurringTransactionsConfig.ts.
// ============================================================================

export const recurringTransactionsEntity = defineEntity<RecurringTransaction>({
  tableConfig: RECURRING_TRANSACTIONS_CONFIG,

  detailConfig: ENHANCED_RECURRING_TRANSACTION_DETAIL_CONFIG,

  synthesizeField(item, fieldId) {
    return getFieldValue(item, fieldId);
  },
});
